export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="others/betslip_warning" clip-path="url(#clip0_3751_99)">
<path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM13.5553 23.3846V28.3077H18.4784V23.3846H13.5553ZM13.5553 4.92308V20.9231H18.4784V4.92308H13.5553Z" fill="#F4301C"/>
</g>
<defs>
<clipPath id="clip0_3751_99">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
